import Observer from '@/common/scripts/observer';
import {Utils} from '@/common/scripts/utils';

const observer = new Observer();

class ParametricFilterContentPopup {
    /* eslint-disable max-statements */
    constructor(options) {
        this.options = options;
        this.elem = Utils.isElement(options.elem) ? options.elem : document.querySelector(options.elem);

        if (!this.elem) {
            console.error(`Element with selector "${options.elem}" not found!`);

            return;
        }

        this.removeDelay = options.removeDelay || 300;
        this.inputSelector = '.j-parametric-select-popup__input';
        this.contentSelector = '.j-parametric-select-popup__content';
        this.valueSelector = '.j-parametric-select-popup__value';
        this.checkSelector = '.j-parametric-select-popup__checkbox';
        this.closeSelector = '.j-parametric-select-popup__close';
        this.itemsWrapSelector = '.j-parametric-select-popup__wrapper';
        this.resetSelector = '.j-parametric-select-popup__reset';
        this.countSelector = '.j-parametric-select-popup__count';
        this.openClass = 'is-open';
        this.closeClass = 'is-close';
        this.checkedClass = 'is-checked';
        this.disableClass = 'is-disabled';

        this.isOpen = false;
        this.summaryPrefix = ['Выбран', 'Выбрано', 'Выбрано'];
    }

    init() {
        if (!this.elem) {
            return;
        }

        this._initElements();
        this._getDataset();

        if (this.elem.classList.contains(this.openClass)) {
            this.open();
        } else {
            this.close();
        }

        this._bindEvents();
        this._changeValue();
    }

    /**
     * Инициализация элементов
     * @private
     */
    _initElements() {
        this.content = this.elem.querySelector(this.contentSelector);
        this.input = this.elem.querySelector(this.inputSelector);
        this.closeButtons = Array.from(this.elem.querySelectorAll(this.closeSelector));
        this.value = this.elem.querySelector(this.valueSelector);
        this.checks = Array.from(this.elem.querySelectorAll(this.checkSelector));
        this.itemsWrap = this.elem.querySelector(this.itemsWrapSelector);
        this.count = this.elem.querySelector(this.countSelector);
        this.resetButton = this.elem.querySelector(this.resetSelector);

        if (this.count) {
            this.countSuffix = this.count.dataset.suffix.split('|');
        }
    }

    /**
     * Берет данные из data-атрибутов
     * @private
     */
    _getDataset() {
        const {placeholder, suffix, prefix, valueType} = this.elem.dataset;

        this.placeholder = placeholder;
        this.suffix = suffix;
        this.prefix = prefix;
        this.valueType = valueType;
    }

    /**
     * Вешает обработчики событий
     * @private
     */
    _bindEvents() {
        this.closeButtons.forEach((button) => {
            button.addEventListener('click', () => {
                this.close();
            });
        });

        this.input.addEventListener('click', () => {
            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        });

        // Чек опшенов
        this.checks.forEach((check) => {
            check.addEventListener('change', () => {
                this._changeValue();
            });
        });

        if (this.resetButton) {
            this.resetButton.addEventListener('click', () => {
                this._resetValues();
            });
        }
    }

    /**
     * Открыть выпадающий список
     */
    open() {
        Utils.bodyStatic();
        Utils.bodyFixed(this.itemsWrap);
        this.elem.classList.add(this.openClass);
        this.isOpen = true;
    }

    /**
     * Закрыть выпадающий список
     */
    close() {
        this.elem.classList.add(this.closeClass);
        setTimeout(() => {
            Utils.bodyStatic();
            this.elem.classList.remove(this.openClass, this.closeClass);
            this.isOpen = false;
            observer.publish('parametric-popup-content:close');
        }, this.removeDelay);
    }

    /**
     * Выводит список выбранного
     * @private
     */
    _changeValue() {
        const text = this.valueType === 'summary' ? this._getSummary() : this._collectText();

        this._insertTextValue(text);
        this._setCountTextValue();
    }

    /**
     * Возвращает строку-список выбранного в формате "Выбрано Х элементов"
     * НЕ ДОРАБОТАНО ДЛЯ ГРУПП ЧЕКБОКСОВ !!!
     * @return {string|*} - итоговая строка
     * @private
     */
    _getSummary() {
        const len = Array.from(this.elem.querySelectorAll(`${this.checkSelector}:checked`)).length;

        if (!len) {
            return this.placeholder;
        }

        const suffix = this.suffix ? Utils.pluralWord(len, this.suffix.split('|')) : '';

        return `${Utils.pluralWord(len, this.summaryPrefix)} ${len} ${suffix}`;
    }

    /**
     * Собирает список выбранного из названий (через запятую)
     * @return {string|*} - итоговая строка
     * @private
     */
    _collectText() {
        let finalText = '';

        for (let i = 0; i < this.checks.length; i++) {
            const check = this.checks[i];

            if (check.checked && check.value === 'reset') {
                finalText = '';

                return this.placeholder;
            }

            finalText = this._getItemsText(check, finalText);
        }

        finalText = finalText.substr(2);

        if (!finalText) {
            return this.placeholder;
        }

        return `${this.prefix ? `${this.prefix} ` : ``}${finalText}`;
    }

    /**
     * Получает текст чекбокса для вывода в строку результатов
     * @param {Element} item - элемент чекбокса
     * @param {string} str - строка, к которой нужно приклеить текст чекбокса
     * @param {boolean} forceGet - true - учитывать чекбокс даже если он не чекнут
     * @return {string|*} - итоговая строка
     * @private
     */
    _getItemsText(item, str, forceGet = false) {
        if (!item.checked && !forceGet) {
            return str;
        }

        const dataText = item.dataset.text;
        let itemText = `, ${dataText}`;

        if (!this.suffix) {
            return str + itemText;
        }

        let finalText = str;

        // Первый символ отмеченного - цифра
        // Подходит для комнат/этажей
        if (!isNaN(Number(dataText.slice(0, 1)))) {
            finalText = str.endsWith(this.suffix) ? str.slice(0, str.length - this.suffix.length) : str;
            itemText = itemText + this.suffix;
        }

        return finalText + itemText;
    }

    /**
     * Подставляет текстовое значение в инпут с результатами выбора
     * @param {string} text - текст, который нужно вставить
     * @private
     */
    _insertTextValue(text) {
        Utils.clearHtml(this.value);
        Utils.insetContent(this.value, text);
    }

    /**
     * Подставляет текстовое значение в кнопку с результатами выбора
     * @private
     */
    _setCountTextValue() {
        if (!this.count) {
            return;
        }

        const count = this.checks.filter((item) => {
            return item.checked;
        }).length;

        const text = count ?
            `Выбрать ${count} ${Utils.pluralWord(count, this.countSuffix)}` :
            `Выбрать`;

        Utils.clearHtml(this.count);
        Utils.insetContent(this.count, text);
    }

    /**
     * Отчекивает все чекнутые чекбоксы
     * @private
     */
    _resetValues() {
        this.checks.filter((item) => {
            return item.checked;
        }).forEach((check) => {
            check.checked = false;
        });
        this._changeValue();
    }

    /**
     * Обновляет псевдоселект снаружи
     */
    update() {
        this._changeValue();
    }
}

export default ParametricFilterContentPopup;
